import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "74.049",
  height: "57.537",
  viewBox: "0 0 74.049 57.537"
}
const _hoisted_2 = { transform: "translate(1 1)" }
const _hoisted_3 = { transform: "translate(14.771 0)" }
const _hoisted_4 = ["stroke"]
const _hoisted_5 = ["stroke"]
const _hoisted_6 = ["stroke"]
const _hoisted_7 = { transform: "translate(4.613 40.157)" }
const _hoisted_8 = ["stroke"]
const _hoisted_9 = ["stroke"]
const _hoisted_10 = { transform: "translate(41.116 0)" }
const _hoisted_11 = ["stroke"]
const _hoisted_12 = ["stroke"]
const _hoisted_13 = ["stroke"]
const _hoisted_14 = ["stroke"]
const _hoisted_15 = ["stroke"]
const _hoisted_16 = { transform: "translate(60.255 25.584)" }
const _hoisted_17 = ["stroke"]
const _hoisted_18 = ["stroke"]
const _hoisted_19 = ["stroke"]
const _hoisted_20 = ["stroke"]
const _hoisted_21 = ["stroke"]
const _hoisted_22 = { transform: "translate(2.046 21.246)" }
const _hoisted_23 = ["stroke"]
const _hoisted_24 = ["stroke"]
const _hoisted_25 = { transform: "translate(2.433 25.584)" }
const _hoisted_26 = ["stroke"]
const _hoisted_27 = ["stroke"]
const _hoisted_28 = ["stroke"]
const _hoisted_29 = ["stroke"]
const _hoisted_30 = ["stroke"]
const _hoisted_31 = ["stroke"]
const _hoisted_32 = ["stroke"]
const _hoisted_33 = ["stroke"]
const _hoisted_34 = { transform: "translate(31.758 13.971)" }
const _hoisted_35 = ["stroke"]
const _hoisted_36 = ["stroke"]
const _hoisted_37 = ["stroke"]
const _hoisted_38 = ["stroke"]
const _hoisted_39 = ["stroke"]


export default /*#__PURE__*/_defineComponent({
  __name: 'IconPower4',
  props: {
  color: {
    type: String,
    default: '#D4D4D4',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("g", _hoisted_3, [
        _createElementVNode("path", {
          d: "M511.277,190.169c0,3.122-2.2,6.013-4.92,6.013s-4.92-2.891-4.92-6.013a4.933,4.933,0,1,1,9.84,0Z",
          transform: "translate(-497.366 -184.878)",
          fill: "none",
          stroke: __props.color,
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, 8, _hoisted_4),
        _createElementVNode("path", {
          d: "M510.257,220.628,509.08,217.2a3.207,3.207,0,0,0-2.829-2.02H496.28a3.206,3.206,0,0,0-2.829,2.02l-1.177,3.431",
          transform: "translate(-492.274 -201.715)",
          fill: "none",
          stroke: __props.color,
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, 8, _hoisted_5),
        _createElementVNode("path", {
          d: "M508.308,230.861l2.231,18.455a1.111,1.111,0,0,1-1.128,1.272H496.022a1.111,1.111,0,0,1-1.128-1.272l2.23-18.455",
          transform: "translate(-493.725 -210.431)",
          fill: "none",
          stroke: __props.color,
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, 8, _hoisted_6),
        _createElementVNode("g", _hoisted_7, [
          _createElementVNode("path", {
            d: "M507.034,275.263v13.243a2.142,2.142,0,0,1-2.136,2.136h-.107a2.142,2.142,0,0,1-2.136-2.136V275.263",
            transform: "translate(-502.656 -275.263)",
            fill: "none",
            stroke: __props.color,
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
          }, null, 8, _hoisted_8),
          _createElementVNode("path", {
            d: "M516.89,275.263v13.243a2.142,2.142,0,0,1-2.136,2.136h-.107a2.142,2.142,0,0,1-2.136-2.136V275.263",
            transform: "translate(-508.133 -275.263)",
            fill: "none",
            stroke: __props.color,
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
          }, null, 8, _hoisted_9)
        ])
      ]),
      _createElementVNode("g", _hoisted_10, [
        _createElementVNode("path", {
          d: "M561.8,190.378c0,3.245-2.29,6.25-5.115,6.25s-5.114-3.006-5.114-6.25a5.128,5.128,0,1,1,10.229,0Z",
          transform: "translate(-551.57 -184.878)",
          fill: "none",
          stroke: __props.color,
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, 8, _hoisted_11)
      ]),
      _createElementVNode("line", {
        y2: "21.378",
        transform: "translate(52.292 20.72)",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_12),
      _createElementVNode("line", {
        y1: "21.378",
        transform: "translate(40.169 20.72)",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_13),
      _createElementVNode("path", {
        d: "M555.509,258.852v18.883a2.779,2.779,0,0,1-2.771,2.771h-.529a2.779,2.779,0,0,1-2.771-2.771V257.022",
        transform: "translate(-509.269 -224.969)",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_14),
      _createElementVNode("path", {
        d: "M569.131,257.022v20.712a2.779,2.779,0,0,1-2.771,2.771h-.53a2.779,2.779,0,0,1-2.771-2.771V258.852",
        transform: "translate(-516.838 -224.969)",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_15),
      _createElementVNode("g", _hoisted_16, [
        _createElementVNode("path", {
          d: "M604.074,245.709a3.037,3.037,0,1,1-6.041,0,3.028,3.028,0,1,1,6.041,0Z",
          transform: "translate(-596.529 -242.461)",
          fill: "none",
          stroke: __props.color,
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, 8, _hoisted_17),
        _createElementVNode("path", {
          d: "M605.279,264.1l-.666-1.942a1.816,1.816,0,0,0-1.6-1.144h-6.533",
          transform: "translate(-595.664 -252.771)",
          fill: "none",
          stroke: __props.color,
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, 8, _hoisted_18),
        _createElementVNode("path", {
          d: "M602.451,269.894l1.263,8.337a.629.629,0,0,1-.638.72h-7.58a.629.629,0,0,1-.638-.72l1.263-8.337",
          transform: "translate(-594.76 -257.706)",
          fill: "none",
          stroke: __props.color,
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, 8, _hoisted_19),
        _createElementVNode("path", {
          d: "M594.647,264.186",
          transform: "translate(-594.647 -254.534)",
          fill: "none",
          stroke: __props.color,
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, 8, _hoisted_20),
        _createElementVNode("path", {
          d: "M611.994,266.727l2.157,6.025a.991.991,0,0,0,1.242.6l.024-.008a.97.97,0,0,0,.607-1.227l-2.686-7.933",
          transform: "translate(-604.287 -254.534)",
          fill: "none",
          stroke: __props.color,
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, 8, _hoisted_21),
        _createElementVNode("g", _hoisted_22, [
          _createElementVNode("path", {
            d: "M601.73,290.28v7.5a1.213,1.213,0,0,1-1.209,1.209h-.061a1.213,1.213,0,0,1-1.209-1.209v-7.5",
            transform: "translate(-599.251 -290.28)",
            fill: "none",
            stroke: __props.color,
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
          }, null, 8, _hoisted_23),
          _createElementVNode("path", {
            d: "M607.31,290.28v7.5a1.213,1.213,0,0,1-1.209,1.209h-.061a1.213,1.213,0,0,1-1.209-1.209v-7.5",
            transform: "translate(-602.352 -290.28)",
            fill: "none",
            stroke: __props.color,
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2"
          }, null, 8, _hoisted_24)
        ])
      ]),
      _createElementVNode("g", _hoisted_25, [
        _createElementVNode("path", {
          d: "M470.759,245.825a3.147,3.147,0,1,1-6.257,0,3.137,3.137,0,1,1,6.257,0Z",
          transform: "translate(-464.502 -242.461)",
          fill: "none",
          stroke: __props.color,
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, 8, _hoisted_26)
      ]),
      _createElementVNode("path", {
        d: "M459.026,267.046v-3.957a1.669,1.669,0,0,1,1.664-1.664h7.245",
        transform: "translate(-459.026 -227.416)",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_27),
      _createElementVNode("line", {
        y2: "10.686",
        transform: "translate(8.7 38.811)",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_28),
      _createElementVNode("line", {
        y1: "10.969",
        transform: "translate(2.422 38.528)",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_29),
      _createElementVNode("path", {
        d: "M467.622,285.293v9.193a1.335,1.335,0,0,1-1.332,1.331h-.482a1.335,1.335,0,0,1-1.332-1.331v-9.911",
        transform: "translate(-462.056 -240.28)",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_30),
      _createElementVNode("path", {
        d: "M474.676,284.575v9.911a1.335,1.335,0,0,1-1.331,1.331h-.482a1.335,1.335,0,0,1-1.331-1.331v-9.193",
        transform: "translate(-465.976 -240.28)",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_31),
      _createElementVNode("path", {
        d: "M461.448,270.641v6.443a1,1,0,0,1-1,1h-.425a1,1,0,0,1-1-1v-6.775",
        transform: "translate(-459.026 -232.352)",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_32),
      _createElementVNode("path", {
        d: "M525.163,230.882l3.811,10.642a4.75,4.75,0,0,0,.474.928,1.677,1.677,0,0,0,.9.628l.041.014a1.751,1.751,0,0,0,2.195-1.061l3.366-10.642",
        transform: "translate(-495.779 -210.443)",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_33),
      _createElementVNode("g", _hoisted_34, [
        _createElementVNode("path", {
          d: "M530.506,220.778l2.96,8.742,1.615-7.629",
          transform: "translate(-530.506 -218.799)",
          fill: "none",
          stroke: __props.color,
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, 8, _hoisted_35),
        _createElementVNode("path", {
          d: "M565.538,236.176l-2.092-2.3a1.691,1.691,0,0,0-.008-1.051l-2.966-14.012-.181-.468a3.206,3.206,0,0,0-2.829-2.02H543.937a3.207,3.207,0,0,0-2.829,2.02l-.176.468-.128.6",
          transform: "translate(-536.228 -216.323)",
          fill: "none",
          stroke: __props.color,
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, 8, _hoisted_36),
        _createElementVNode("path", {
          d: "M576.729,232.028,580.1,242.67a1.746,1.746,0,0,0,1.469,1.138L586,248.791",
          transform: "translate(-556.193 -225.05)",
          fill: "none",
          stroke: __props.color,
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, 8, _hoisted_37)
      ]),
      _createElementVNode("path", {
        d: "M478.393,249.285a1.508,1.508,0,0,0,.718-.585l3.4-5.143c.7-.015,1.361-1.34,1.609-2.033l3.811-10.642",
        transform: "translate(-469.789 -210.443)",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_38),
      _createElementVNode("path", {
        d: "M485.953,220.778,481.21,234.79a1.688,1.688,0,0,0-.039.939l-2.071,3.108",
        transform: "translate(-470.182 -204.828)",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_39)
    ])
  ]))
}
}

})